import cogoToast from 'cogo-toast';
import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders, uaeProjectsBaseURL } from '../../../../Containers/Config/index.js';
import { Constant } from '../../../../Containers/Helpers/constant.js';
import apiCall from '../../apiCall.js';

import { POST_COUPONS, POST_COUPONS_SUCCESS, POST_COUPONS_ERROR } from './../../actionType.js';

function* postCoupon({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${uaeProjectsBaseURL}/admin/uploadFiles`,
      method: 'POST',
      data: payload.data,
      isFormData: true,
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
      },
    });

    if (response.status === 200) {
      cogoToast.success('File uploaded successfully');
      yield put({
        type: POST_COUPONS_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(`${response?.response?.data?.message}`);
      yield put({ type: POST_COUPONS_ERROR, payload: response.data.message });
    }
  } catch (error) {
    yield put({ type: POST_COUPONS_ERROR, payload: error });
  }
}

export function* watchPostCoupon() {
  yield takeEvery(POST_COUPONS, postCoupon);
}

function* postCouponSaga() {
  yield all([fork(watchPostCoupon)]);
}

export default postCouponSaga;
